import React from 'react';
import { FlatButton, FontIcon, RaisedButton } from 'material-ui';
import R from 'ramda';
import { connect } from 'react-redux';
import {
  addDraftToQueue as addDraftToQueueAction,
} from '../../__storeFiles__/actions';

const DraftComplete = ({
  isTemplateDraft,
  sentPartners,
  leftNav,
  publishDraft,
  updateProps,
  draftApproved,
  reviewRateEmailSent,
  sendReviewRatesEmail,
}) => {
  const templateDraftWithoutPartners = isTemplateDraft && R.isEmpty(sentPartners);
  const isEditedDraft = leftNav.originFrom === 'edited';
  const isContractDraft = isEditedDraft && leftNav.draftType !== 'template';
  const activeDraft = isContractDraft || Boolean(sentPartners && sentPartners.length);
  // for first version only
  if (draftApproved !== true && !activeDraft) {
    return (
      <div style={{ textAlign: 'center' }}>
        {
          Boolean(reviewRateEmailSent) ? (
            <div style={{ fontSize: '20x', margin: '16px', padding: '16px 40px' }}>
              A rate expert has received your rates and will be in contact with your shortly to schedule a call with you.
            </div>
          ) : (
            <div style={{ margin: '16px', padding: '16px 40px' }}>
              <div style={{ fontSize: '20x' }}>
                We would be happy to review your rates, for FREE, to help make sure your rates are easy for your partners to load - and sell!
              </div>
              <div style={{ marginTop: '32px' }}>
                <FlatButton
                  label="Schedule A Review"
                  labelStyle={{ textTransform: 'none' }}
                  style={{ border: '1px solid #ff4081' }}
                  primary
                  onTouchTap={sendReviewRatesEmail}
                />
                <RaisedButton
                  label={`Finalise Template`}
                  labelStyle={{ textTransform: 'none' }}
                  secondary
                  style={{ marginLeft: '12px' }}
                  onTouchTap={publishDraft}
                />
              </div>
            </div>
          )
        }
        {
          /*
                  <div style={{ marginTop: '20px' }}>
          <FlatButton
            label="Continue Editing"
            labelStyle={{ textTransform: 'none' }}
            onTouchTap={onRequestClose}
            icon={<FontIcon className="tc-icon-mode_edit" style={{ fontSize: '22px', marginLeft: '8px' }} />}
          />
          <FlatButton
            label="Review PDF"
            labelStyle={{ textTransform: 'none' }}
            onTouchTap={(e) => downloadContractPdf(e.currentTarget)}
            icon={<FontIcon className="tc-icon-picture_as_pdf" style={{ fontSize: '22px', marginLeft: '8px' }} />}
          />
        </div>
           */
        }
      </div>
    );
  }
  return (
    <div>
      <div>
        <div style={{ padding: '18px' }}>
            <p style={{ color: '#00bcd4', fontSize: '14px', marginLeft: '24px' }}>
              Your template is 100% complete.
            </p>
          <p style={{ fontSize: '16px', marginLeft: '24px', color: '#616161' }}>
            Would you like to keep working on your templates or select your partners and send these rates now?
          </p>
        </div>
    </div>
      <div style={{ margin: '24px 32px', textAlign: 'center' }}>
        <FlatButton
          label="Finalise & Send Later"
          labelStyle={{ textTransform: 'none' }}
          secondary
          onTouchTap={publishDraft}
          style={{ border: '1px solid #00bcd4' }}
        />
        <RaisedButton
          label="Finalise & Continue"
          labelStyle={{ textTransform: 'none' }}
          secondary
          onTouchTap={() => publishDraft({ goToSend: true })}
          style={{ marginLeft: '16px' }}
        />
      </div>
    </div>
  );
};

const mapStateToProps = ({ contracting }) => {
  const leftNav = contracting.contractActivitiesProducts.get('leftNav');
  return ({
    isTemplateDraft: leftNav.get('draftType') === 'template' || leftNav.get('originFrom') !== 'edited',
    originFrom: leftNav.get('originFrom'),
    sentPartners: leftNav.get('sentPartners') ? leftNav.get('sentPartners').toJS() : [],
  });
};

export default connect(mapStateToProps, { addDraftToQueue: addDraftToQueueAction })(DraftComplete);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/publish-draft-content/draft-complete.jsx